<template>
    <b-form-datepicker
            v-model="inputVal"
            :value-as-date="true"
            :state="state"
            :disabled="disabled"
            label-no-date-selected="Veuillez sélectionner une date"
            label-help=""
            label-prev-year="Année précédente"
            label-prev-month="Mois précédent"
            label-current-month="Mois courant"
            label-next-month="Mois suivant"
            label-next-year="Année suivante">
    </b-form-datepicker>
</template>

<script>
  import {momentToDate} from "../utils/dateUtil";
  import moment from 'moment';

  export default {
    name: "DatepickerCustom",
    props: ['value', 'state', 'disabled'],
    computed: {
      inputVal: {
        get() {
          return this.value;
        },
        set(value) {
          if (value) {
          this.$emit('input', momentToDate(moment(value)));
          }
        }
      }
    },
    watch: {
      inputVal: function (newVal, oldVal) {
        if (!oldVal) {
          this.inputVal = newVal ? new Date(newVal) : null;
        }
      }
    },
  };
</script>
